import { TIER_META, normalizeTier } from "@/constants";

export default function TierBadge({ tier, size = "md", showTagline = false, showGem = true }) {
  const normalized = normalizeTier(tier);
  const meta = TIER_META[normalized] || TIER_META.commercial;
  const sizes = {
    sm: "px-2.5 py-0.5 text-[11px]",
    md: "px-3 py-1 text-xs",
    lg: "px-4 py-1.5 text-sm",
  };
  return (
    <span
      data-testid={`tier-badge-${normalized}`}
      className={`inline-flex items-center gap-1.5 rounded-full border ${meta.className} ${sizes[size]} font-semibold uppercase tracking-wider`}
      title={`${meta.tagline} · Nivel ${meta.gem}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
      {showGem && meta.gem && (
        <span data-testid={`tier-badge-gem-${normalized}`}
          className="inline-flex items-center gap-1 pl-1.5 ml-1 border-l"
          style={{ color: meta.gemColor, borderColor: meta.gemColor + "55" }}>
          <span aria-hidden>{meta.gemIcon}</span>
          <span className="text-[10px] font-bold tracking-widest">{meta.gem}</span>
        </span>
      )}
      {showTagline && meta.tagline && (
        <span className="font-hand normal-case tracking-normal text-[var(--ink-soft)] ml-1 lowercase text-[10px]">
          · {meta.tagline}
        </span>
      )}
    </span>
  );
}
